import { ServiceResponse } from "../../api/ServiceResponse";
import { PumpPortDto } from "./PumpPortDto";

export class PumpPortResponse extends ServiceResponse {
  pumpPortList?: PumpPortDto[];
  count?: number;

  constructor(init?: Partial<PumpPortResponse>) {
    super(init);
    Object.assign(this, init);
  }

  // Getters & Setters
  getPumpPortList(): PumpPortDto[] | undefined {
    return this.pumpPortList;
  }
  setPumpPortList(value: PumpPortDto[] | undefined): void {
    this.pumpPortList = value;
  }

  getCount(): number | undefined {
    return this.count;
  }
  setCount(value: number | undefined): void {
    this.count = value;
  }
}
